import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { materialPropType } from 'types/PDPTypes';
import Currency from 'components/consumer/Currency';
import Checkbox from 'components/consumer/Checkbox';
import CtaButton from 'components/essentials/Cta/CtaButton';

import PDPAlertBar from '../PDPAlertBar';
import usePdpEditOrderErrorMessage from '../state/pdpEditOrderErrorMessage/usePdpEditOrderErrorMessage';

const PDPFabricUpChargeModal = loadable(() =>
  import('../PDPFabricUpChargeModal')
);

const PDPCompleteOrderUI = ({
  loading,
  orderId,
  cartItem,
  isChecked,
  showModal,
  orderInfo,
  updateOrder,
  setIsChecked,
  setShowModal,
  selectedMaterial,
  onCompletedOrderClick,
  orderUpChargeSummaryData,
}) => {
  const editOrderErrorMessage = usePdpEditOrderErrorMessage();
  const additionalCost = selectedMaterial?.additionalCost;

  return (
    <div className="PDPCompleteOrderUI">
      {additionalCost > 0 && (
        <PDPAlertBar type="info">
          Your selected material has an additional charge of{' '}
          <Currency>{additionalCost}</Currency>
        </PDPAlertBar>
      )}
      <div className="mx-0 my-6 [&_label]:text-sm">
        <Checkbox
          onChange={() => {
            setIsChecked(!isChecked);
          }}
          checked={isChecked}
          size="sm"
        >
          I understand product options will be finalized and I cannot make any
          further changes
        </Checkbox>
      </div>
      <div className="PDPCompleteOrderUI__complete-order">
        <CtaButton
          disabled={!isChecked || loading}
          data-xc="edit-order-button"
          onClick={onCompletedOrderClick}
          styling="solid-button"
          color="black"
          block
          isLoading={loading}
        >
          Complete order
        </CtaButton>
        {editOrderErrorMessage && (
          <div className="text-sm font-bold text-red mx-0 my-1 text-center">
            {editOrderErrorMessage}
          </div>
        )}
      </div>
      {showModal && orderId && cartItem && (
        <PDPFabricUpChargeModal
          orderId={orderId}
          cartItem={cartItem}
          orderInfo={orderInfo}
          updateOrder={updateOrder}
          onClose={() => setShowModal(false)}
          selectedMaterial={selectedMaterial}
          editOrderErrorMessage={editOrderErrorMessage}
          orderUpChargeSummaryData={orderUpChargeSummaryData}
        />
      )}
    </div>
  );
};

PDPCompleteOrderUI.propTypes = {
  loading: PropTypes.bool,
  orderId: PropTypes.string,
  cartItem: PropTypes.shape({
    slug: PropTypes.string,
  }),
  orderInfo: PropTypes.shape({
    shipping: PropTypes.shape({
      address_first_name: PropTypes.string,
      address_last_name: PropTypes.string,
    }),
    customer: PropTypes.shape({
      customer_email: PropTypes.string,
    }),
  }),
  showModal: PropTypes.bool,
  isChecked: PropTypes.bool,
  setShowModal: PropTypes.func,
  setIsChecked: PropTypes.func,
  updateOrder: PropTypes.func,
  selectedMaterial: materialPropType,
  onCompletedOrderClick: PropTypes.func,
  orderUpChargeSummaryData: PropTypes.object,
};

export default PDPCompleteOrderUI;
